<div class="update-modal-content">
  <ion-icon name="sparkles-outline" class="update-icon"></ion-icon>

  <h2 class="update-title">{{ 'UPDATE.MODAL_TITLE' | translate }}</h2>

  <p class="update-body">{{ 'UPDATE.READY' | translate }}</p>

  <p class="update-version">{{ 'UPDATE.NEW_VERSION' | translate }}</p>

  <div class="update-actions">
    <ion-button expand="block" color="primary" (click)="reload()">
      <ion-icon slot="start" name="refresh-outline"></ion-icon>
      {{ 'UPDATE.RELOAD' | translate }}
    </ion-button>

    <ion-button expand="block" fill="clear" color="medium" (click)="dismiss()">
      {{ 'UPDATE.LATER' | translate }}
    </ion-button>
  </div>
</div>
